import styled, { css, keyframes } from 'styled-components';

// Definir un color base predeterminado
const defaultBaseColor = '#eee';
const defaultHighlightColor = '#f5f5f5';

// Definir los tipos para las props del componente Skeleton
interface SkeletonProps {
    circle?: boolean;
    width?: string;
    height?: string;
    duration?: number;
}

// Crear una keyframe para la animación
const skeletonKeyframes = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

// Crear el componente Skeleton
const Skeleton = styled.div<SkeletonProps>`
    border-radius: 4px;
    width: 100%;
    ${(props) =>
        props.circle &&
        css`
            border-radius: 50%;
        `}
    ${(props) =>
        props.width &&
        css`
            width: ${props.width};
        `}
  ${(props) =>
        props.height &&
        css`
            height: ${props.height};
        `}
  background-color: ${defaultBaseColor};
    background-image: linear-gradient(90deg, ${defaultBaseColor}, ${defaultHighlightColor}, ${defaultBaseColor});
    background-size: 200px 100%;
    background-repeat: no-repeat;
    margin: 0.5rem 0;
    display: block;
    line-height: 1;
    animation: ${skeletonKeyframes} ${(props) => props.duration}s ease-in-out infinite;
`;

Skeleton.defaultProps = {
    duration: 1.2,
    circle: false,
};

export default Skeleton;
